/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { UserFilterWrap } from '@views/Home/index.style'
import { Radio } from 'antd'
import { UserPickProfile } from '@views/Home/UserPick/Components/UserPickProfile'
import _ from 'lodash'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { Schema$UserPickUserInfo } from '@interface/user-pick'
import { EXCEPTIONAL_UNIQUE_ID, FROM_VIEW_TYPE } from '@v2/constants/common'
import AllMember from '@assets/images/icon/tab_icon/all-tab.png'
import { ALL_MEMBER_USER_PICK_KEY } from '@constants/index'

interface Props {
  className?: string
  fromView: FROM_VIEW_TYPE
  selectedUserPromiseIds: string[]
  onChange: (selectedUserPromiseIds: string[]) => void
}

export const UserPickMemberFilter: React.FC<Props> = observer((props: Props) => {
  const { userPickStore, matchupStore } = useRootStore()
  const { className, fromView, selectedUserPromiseIds, onChange } = props
  const { majorUniqueID } = matchupStore
  const {
    userInfos,
    notStartedMatchCount,
    startedMatchCount,
    closedMatchCount,
    favoriteMatchIds,
    monthlyBestUserPickUserInfos,
    totalMonthlyBestUserPickCount,
    isMatchPackageLoading,
  } = userPickStore

  const onChangeMemberFilter = (e) => {
    const selectedValue = e.target.value
    if (_.isFunction(onChange)) {
      onChange([selectedValue])
    }
  }

  const allUserInfo = useMemo<Schema$UserPickUserInfo>(() => {
    let matchCount = 0
    if (fromView === FROM_VIEW_TYPE.TODAY_USER_PICK_POPUP) {
      matchCount = totalMonthlyBestUserPickCount
    } else {
      if (majorUniqueID === EXCEPTIONAL_UNIQUE_ID.NOT_STARTED_USER_PICK) {
        matchCount = notStartedMatchCount
      } else if (majorUniqueID === EXCEPTIONAL_UNIQUE_ID.STARTED_USER_PICK) {
        matchCount = startedMatchCount
      } else if (majorUniqueID === EXCEPTIONAL_UNIQUE_ID.CLOSED_USER_PICK) {
        matchCount = closedMatchCount
      } else if (majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
        matchCount = _.size(favoriteMatchIds)
      }
    }
    return {
      userNick: '전체',
      userProfileImg: AllMember,
      matchCount,
      monthlyBestPickCount: 0,
      heart: 0,
      betTicket: 0,
      userTitleId: undefined,
      userTitleEnabled: true,
    }
  }, [notStartedMatchCount, startedMatchCount, favoriteMatchIds, totalMonthlyBestUserPickCount])

  const userFilterWrapClassName = classNames(
    'user-pick-user-filter-wrap',
    { 'mo-user-filter-wrap': isMobile },
    { 'pc-user-filter-wrap': !isMobile },
    { 'is-loading': isMatchPackageLoading },
  )

  const userPickUserInfos: Schema$UserPickUserInfo[] = useMemo(() => {
    if (fromView === FROM_VIEW_TYPE.TODAY_USER_PICK_POPUP) {
      return monthlyBestUserPickUserInfos
    } else {
      return userInfos
    }
  }, [userInfos, monthlyBestUserPickUserInfos])

  return (
    <UserFilterWrap className={className ? `${userFilterWrapClassName} ${className}` : userFilterWrapClassName}>
      <Radio.Group
        key="additionalDividendCardGroup"
        value={selectedUserPromiseIds.join()}
        onChange={onChangeMemberFilter}
        defaultValue="allSpecialMember"
      >
        <Radio.Button
          key={`UserPick:userFilter:${ALL_MEMBER_USER_PICK_KEY}`}
          value={ALL_MEMBER_USER_PICK_KEY}
          checked
        >
          <div className="tab-item">
            <UserPickProfile
              userInfo={allUserInfo}
              showNick
              showBg
              showMatchCount
            />
          </div>
        </Radio.Button>
        {_.map(userPickUserInfos, userInfo =>
          <Radio.Button
            key={`UserPick:userFilter:${userInfo.userPromiseId}`}
            value={userInfo.userPromiseId}
          >
            <div className="tab-item">
              <UserPickProfile userInfo={userInfo} showNick showBg showMatchCount showSMark={userInfo.hasMark}/>
            </div>
          </Radio.Button>,
        )}
      </Radio.Group>
    </UserFilterWrap>
  )
})
